interface SettingValue {
  readonly key: string;
  readonly value?: string | null;
}

export function getSettingValue(
  settings: readonly SettingValue[] | undefined,
  key: string,
): string | undefined {
  return settings?.find((setting) => setting.key === key)?.value ?? undefined;
}

export function isSettingEnabled(
  settings: readonly SettingValue[] | undefined,
  key: string,
): boolean {
  return getSettingValue(settings, key)?.trim().toLowerCase() === "true";
}
